<template>
	<div class="companyInfo" >
		<div class="header_ContentBox p-l-10 p-r-10">
			<i class="zb zb-u97 Icon"></i>
			<span class="header_text">/ 企业管理 / 企业介绍</span>
		</div>
		<div class="companybox content_Box box-shadow m-t-15 p-l-10 p-r-10" :style="{'min-height': windowSizeHeight-120 +'px'}">
			
		</div>	
	</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	import {
		publicData
	} from '../assets/js/data.js';
	export default {
		name: 'companyInfo',
		data() {
			return {
				url: common.url,
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
				
			}
		},
		mounted() {
			this.startResult();
		},
		methods: {
			startResult() {
				if (!sessionStorage.getItem('userInfo')) { //是否登录
					window.location = 'login.html';
					return;
				}
				
			},
			 
		},
	}
</script>

<style scoped>
	.companybox .headerBox {
		height: 35px;
		line-height: 35px;
		font-size: 16px;
		padding-left: 10px;
		border-bottom: 1px solid #E8E8E8;
		font-weight: 700;
		color: #333333;
	}
</style>



// WEBPACK FOOTER //
// src/components/LhygCompanyInfo.vue